<template>
  <div class="about-container">
    <div class="about-content">
      <h1 class="section-title"><strong>About PlantPP</strong></h1>
      <p>PlantPP (Plant Phylogenetic Profiling) is an online tool developed which dedicated to predicting the functions and interactions of plant genes through evolutionary analysis. Compare the distribution patterns of homologous genes across species by standardizing the conservation scores of genes across species. Identify candidate genes that have co-evolved with a target gene and infer potential functions or interactions. Based on the conserved patterns of genes in the evolutionary tree of life, PlantPP provides botanical researchers with an efficient and precise means of functional annotation and systems biology research.</p>

      <h2 class="section-title"><strong>Core Functions</strong></h2>
      <p>PlantPP is designed for gene co-evolution analysis across a wide range of plant species. Its core functions include: 1)Predicting the functions of less-studied genes and 2) Identifying gene co-evolution networks.There are two analytical modes are implemented in the platform:</p>
      <ul>
        <li><strong>Global mode:</strong> capture co-evolutionary signals of genes across the tree of life.</li>
        <li><strong>Local mode:</strong> Focus on the evolutionary context of specific plant taxa to enhance prediction specificity.</li>
      </ul>

      <h2 class="section-title"><strong>Team and Acknowledgments</strong></h2>
      <p>PlantPP was developed by AI4Breeding Team from CAAS. We thank the contributors of open source tools (BioPython, clusterProfiler, etc.) and public databases (NCBI, Ensembl Plants, etc.).</p>

      <h2 class="section-title"><strong>Use and Collaboration</strong></h2>
      <ul>
        <li><strong>Immediate use: </strong> <router-link to="/analyze">Click here to launch the analysis</router-link> </li>
        <li><strong>Technical Support:</strong> For questions, please contact lihuihui@caas.cn</li>
        <li><strong>Version information:</strong> v1.0 (updated May 2025)</li>
      </ul>

      <h2 class="section-title"><strong>Contact Us</strong></h2>
      <p>
        <strong>Address:</strong> <a href="javascript:void(0)" @click="handleLocation">Institute of Crop Science, Chinese Academy of Agricultural Sciences, 12 Zhongguancun South Street, Haidian District, Beijing, China</a><br>
        <strong>Zip code:</strong> 100081<br>
        <strong>E-mail:</strong> lihuihui@caas.cn
      </p>

      <h2 class="section-title"><strong>Disclaimer</strong></h2>
      <p>This tool is intended for scientific research use only and the results are for reference only. We do not guarantee the absolute accuracy of the data and are not responsible for any consequences arising from the use of this tool.</p>

      <h2 class="section-title"><strong>Reference Citation</strong></h2>
      <p>Gao, Shang, et al. "Mining salt stress-related genes in Spartina alterniflora via analyzing co-evolution signal across 365 plant species using phylogenetic profiling." Abiotech 4.4 (2023): 291-302.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      latitude: 12950609.10493317,
      longitude: 4833299.8297012225
    }
  },
  methods: {
    handleLocation() {
      const url = `http://api.map.baidu.com/marker?location=${this.latitude},${this.longitude}&title=${encodeURIComponent('PlantPP')}&content=${encodeURIComponent('定位')}&output=html`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.about-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.about-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-title {
  margin-top: 25px;
  margin-bottom: 15px;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

h1.section-title {
  font-size: 28px;
  margin-top: 0;
}

h2.section-title {
  font-size: 22px;
}

p {
  line-height: 1.6;
  margin-bottom: 15px;
  color: #606266;
}

ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

li {
  margin-bottom: 8px;
  color: #606266;
}

a {
  color: #627fd4;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
